import {apiUrl} from "./api_url";

export async function start_api() {
    const token = localStorage.getItem('accessToken');
    if (!token) {
        throw new Error({"message":"Authorization token required","authorized":false});
    }

    try {
        const response = await fetch(`${apiUrl}/candle-direction/start`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });

        const data = await response.json();

        if (response.ok) {
            return data.message;
        } else {
            throw new Error(data.message);
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}
